/**
 * KİLİTLİ KABİLİYET — "bu ücretli bir kabiliyet" ifadesi.
 *
 * CLAUDE.md §6: kilitli kabiliyet bir anormallik DEĞİLDİR. Uyarı işareti
 * (üçgen/ünlem), "—" ve yargı rengi (sarı/kırmızı/yeşil) KULLANILMAZ; sade
 * bir kilit çizgisi, düz cümle ve Abonelik kartına bağlantı.
 */

import { routeHref } from "../lib/router";
import { cx } from "../ui/primitives";
import { M } from "../dil";

export const ABONELIK_ADRESI = `${routeHref("ayarlar")}?bolum=abonelik`;

export function KilitSimgesi({ className }: { readonly className?: string }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 16 16"
      className={cx("inline-block h-[1em] w-[1em] align-[-0.125em]", className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <rect x="3" y="7" width="10" height="7" rx="1.5" />
      <path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" />
    </svg>
  );
}

/**
 * Satır içi ifade: "<ne> ücretli bir kabiliyet · Abonelik". `kisa` verilirse
 * yalnızca kilit + kısa metin (tablo hücresi, kutu değeri).
 */
export function KilitliKabiliyet({
  ne,
  aciklama,
  kisa,
  className,
}: {
  /** Kilitli olan şey, cümle başı: "Üçüncü hesap", "Geçmiş bir güne bakmak". */
  readonly ne: string;
  /** İsteğe bağlı ikinci cümle (ör. ücretsiz sınırın ne olduğu). */
  readonly aciklama?: string;
  readonly kisa?: string;
  readonly className?: string;
}) {
  if (kisa !== undefined) {
    return (
      <span className={cx("text-muted", className)} title={M.ayarlar.kilit.ucretli(ne)}>
        <KilitSimgesi /> {kisa}
      </span>
    );
  }
  return (
    <p role="note" aria-label={M.ayarlar.kilit.etiket} className={cx("text-[12px] text-muted", className)}>
      <KilitSimgesi /> {M.ayarlar.kilit.ucretli(ne)}{aciklama === undefined ? "" : ` ${aciklama}`}{" "}
      <a className="underline" href={ABONELIK_ADRESI}>
        {M.ayarlar.kilit.abonelik}
      </a>
    </p>
  );
}
